import React from 'react';
import PropTypes from 'prop-types';
import { find, map, forEach } from 'lodash';
import { Form, Button } from 'react-bootstrap';
import PageHeader from '../../atoms/PageHeader';
import Validation from '../../containers/Validation';
import * as nodeOps from '../../../api/Tasks/task-node-operations';
import * as paramOps from '../../../api/Tasks/task-param-operations';
import { SUBTASK_PARAM_TYPES } from '../../../api/Tasks/taskConstants';
import SubtaskBooleanField from '../../atoms/SubtaskBooleanField';
import SubtaskDateField from '../../atoms/SubtaskDateField';
import SubtaskNumberField from '../../atoms/SubtaskNumberField';
import SubtaskSelectField from '../../atoms/SubtaskSelectField';
import SubtaskTextField from '../../atoms/SubtaskTextField';

class SubtaskParameters extends React.Component {
  state = {};

  render() {
    const { task, selectedNodeId, saveSubtaskParams, close } = this.props;

    const selectedNode = find(task.nodes, ['id', selectedNodeId]);
    if (!nodeOps.isSubTask(selectedNode)) {
      return null;
    }
    const paramFields = map(nodeOps.getParamList(selectedNode), parameter => {
      if (paramOps.hasOptions(parameter)) {
        return <SubtaskSelectField parameter={parameter} key={paramOps.getId(parameter)} />;
      }
      switch (paramOps.getType(parameter)) {
        case SUBTASK_PARAM_TYPES.STRING:
          return <SubtaskTextField parameter={parameter} key={paramOps.getId(parameter)} />;
        case SUBTASK_PARAM_TYPES.NUMBER:
          return <SubtaskNumberField parameter={parameter} key={paramOps.getId(parameter)} />;
        case SUBTASK_PARAM_TYPES.BOOLEAN:
          return <SubtaskBooleanField parameter={parameter} key={paramOps.getId(parameter)} />;
        case SUBTASK_PARAM_TYPES.DATE:
          return <SubtaskDateField parameter={parameter} key={paramOps.getId(parameter)} />;
        default:
          return <SubtaskTextField parameter={parameter} key={paramOps.getId(parameter)} />;
      }
    });
    const validationProps = {
      rules: {},
      messages: {},
      submitHandler: form => {
        saveSubtaskParams(form);
      }
    };

    forEach(nodeOps.getParamList(selectedNode), parameter => {
      validationProps.rules[paramOps.getId(parameter)] = {
        required: paramOps.isRequired(parameter)
      };
      if (paramOps.isRequired(parameter)) {
        validationProps.messages[paramOps.getId(parameter)] = {
          required: `The ${paramOps.getLabel(parameter)} is required`
        };
      }
      validationProps.rules[paramOps.getId(parameter)] = {
        required: paramOps.isRequired(parameter)
      };
    });

    return (
      <>
        <PageHeader>
          <h5>{nodeOps.getLabel(selectedNode)}</h5>
        </PageHeader>
        <Validation {...validationProps}>
          <Form onSubmit={event => event.preventDefault()} id={nodeOps.getId(selectedNode)}>
            {paramFields}
            <br />
            <div className="d-flex flex-row justify-content-end">
              <Button variant="danger" onClick={close}>
                Cancel
              </Button>
              <Button type="submit" variant="success">
                Save Changes
              </Button>
            </div>
          </Form>
        </Validation>
      </>
    );
  }
}

SubtaskParameters.propTypes = {
  task: PropTypes.object.isRequired,
  selectedNodeId: PropTypes.string.isRequired,
  saveSubtaskParams: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired
};

export default SubtaskParameters;
